/* ================================================================
   MVB — VITRINE COUPE-VENTS (version accueil)

   Le seul comportement de la section : cliquer une pastille change
   la photo, le nom, la couleur, le prix et le lien « Découvrir ».
   Ni taille ni ajout au panier : ça appartient à la fiche produit.

   Installé une seule fois, en délégation sur document, parce que
   Dawn réinjecte les sections en innerHTML dans l'éditeur de thème
   et qu'un <script> réinjecté de cette façon ne s'exécute jamais.

   ATTENTION AUX SÉLECTEURS DE PRIX : les pastilles portent elles
   aussi data-mvb-prix et data-mvb-barre (c'est là qu'est stockée la
   valeur de chaque coloris). Un querySelector('[data-mvb-prix]')
   attrape donc la première pastille, pas le prix affiché, et le
   prix ne bouge jamais à l'écran. D'où le passage par .mvb-prix.
   ================================================================ */
(function () {
  if (window.__mvbVitrineInstalle) return;
  window.__mvbVitrineInstalle = true;

  function pose(section, bouton) {
    var i = bouton.getAttribute('data-mvb-i');

    section.querySelectorAll('[data-mvb-pastille]').forEach(function (b) {
      var actif = b === bouton;
      b.classList.toggle('mvb-on', actif);
      b.setAttribute('aria-pressed', actif ? 'true' : 'false');
    });

    section.querySelectorAll('.mvb-photo').forEach(function (img) {
      img.classList.toggle('mvb-on', img.getAttribute('data-mvb-i') === i);
    });

    var nom = section.querySelector('[data-mvb-nom-produit]');
    if (nom) nom.textContent = bouton.getAttribute('data-mvb-titre') || nom.textContent;

    var couleur = section.querySelector('[data-mvb-couleur]');
    if (couleur) couleur.textContent = bouton.getAttribute('data-mvb-nom') || '';

    var zone = section.querySelector('.mvb-prix');
    if (zone) {
      var prix = zone.querySelector('b');
      if (prix) prix.textContent = bouton.getAttribute('data-mvb-prix') || '';

      var barre = zone.querySelector('s');
      if (barre) {
        var v = bouton.getAttribute('data-mvb-barre') || '';
        barre.textContent = v;
        barre.hidden = v === '';
      }
    }

    var lien = section.querySelector('[data-mvb-lien]');
    if (lien) lien.setAttribute('href', bouton.getAttribute('data-mvb-url') || '#');
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var bouton = e.target.closest('[data-mvb-pastille]');
    if (!bouton) return;
    var section = bouton.closest('.mvb');
    if (!section) return;
    pose(section, bouton);
  });

  /* Clavier : flèches gauche/droite entre les pastilles. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    if (!e.target || !e.target.closest) return;
    var bouton = e.target.closest('[data-mvb-pastille]');
    if (!bouton) return;
    var section = bouton.closest('.mvb');
    if (!section) return;

    var liste = Array.prototype.slice.call(section.querySelectorAll('[data-mvb-pastille]'));
    var pos = liste.indexOf(bouton);
    if (pos === -1) return;
    var cible = liste[(pos + (e.key === 'ArrowRight' ? 1 : liste.length - 1)) % liste.length];
    e.preventDefault();
    cible.focus();
    pose(section, cible);
  });
})();